export const php = {
  configuration: {
    code: "PHP code",
    warning: "Warning"
  }
};
